const FlowZIndex = {
  EDGES: 1,
  REGULAR_NODE: 2,
  /** Dragged (in-progress) connection line. React Flow elevates a *selected* node by +1000
   * (elevateNodesOnSelect), so a selected REGULAR_NODE sits at 1002 — above React Flow's default
   * connection-line z-index of 1001, which hides the line + its endpoint circle behind the node.
   * Keep the dragged line above any selected node. Revisit if REGULAR_NODE changes or
   * elevateEdgesOnSelect is enabled (committed edges would then reach ~1003+). */
  CONNECTION_LINE: 1003,
  /** Group nodes, their children and edges are stacked above regular nodes and stacked
   * against each other using dynamic z-index values.
   * Groups start at 1 and increment by 3 for each subsequent group.
   * We support up to 166 groups (3 * 166 = 498)
   */
  NODE_HANDLE: 500, // Must be above max node z-index (96 for group children)
  /** Sticky-note placement overlay. Sits at the React Flow root level: above the canvas renderer
   * (.react-flow__renderer, z-index 4, via DOM order) but below the floating panels
   * (.react-flow__panel, z-index 5), so panels stay clickable while the tool is armed. */
  STICKY_NOTE_OVERLAY: 4,
  /** Comment pins and the new-comment composer, at the React Flow root level: above nodes (.react-flow__renderer,
   * z-index 4, via DOM order) and below the floating panels (.react-flow__panel, z-index 5). */
  COMMENTS_LAYER: 4,
  /** Zoom tool (Z) overlay and its drag-to-zoom rectangle, at the React Flow root level. Must clear
   * .react-flow__renderer (z-index 4) for the rectangle to draw above nodes; unlike STICKY_NOTE_OVERLAY
   * it also covers the floating panels (.react-flow__panel, z-index 5) while the tool is armed. */
  ZOOM_OVERLAY: 10,
};

const PanelsZIndex = {
  /** Standard panels (Property drawer, Left menu, etc.) use ReactFlow Panel components and don't need explicit z-index values */
  /** ReactFlow's own panel layer, for a panel that can't be a ReactFlow `Panel` (see WorkflowRightPanel) */
  REACT_FLOW_PANEL: 5,
  /** Recipe overlay panels that cover the ReactFlow canvas (e.g., Media Gallery, Design App, Editor, Dialog overlays) */
  RECIPE_OVERLAY_PANELS: 550,
};

const OverlaysZIndex = {
  /** Below LOADING_OVERLAY and modals: a resize drag can't run while those are open. */
  NODE_RESIZE_CURSOR: 900,
  LOADING_OVERLAY: 1000,
  STICKY_TOP_BANNER: 1100,
  PRODUCT_TOUR_OVERLAY: 1200,
  CONTEXT_MENUS_POPOVERS: 1300,
  CONFIRMATION_DIALOGS: 1400, // Above all context inside app
  /** Font menus, selects, and other anchored panels opened from within dialogs (must stack above CONFIRMATION_DIALOGS). */
  ANCHORED_POPPER_ABOVE_DIALOG: 1450,
  /** Global snackbar toasts (must stack above modals and dialog-anchored poppers). */
  APP_SNACKBAR: 1500,
  CRITICAL_SYSTEM_ALERT: 9999, // Above all else
};

export const ZIndex = {
  // Flow components have a separate z-index context and are always below panels and modals.
  // Modals should have a higher z-index range so that they are above all.
  Flow: FlowZIndex,
  Panels: PanelsZIndex,
  Overlays: OverlaysZIndex,
};
